<template>
    <div class="dashboard-container">
        <ProgressSpinner v-if="loading" />
        <div class="charts-wrapper">
            <!-- Chart 2201 -->
            <div class="chart-box">
                <div class="chart-card">
                    <h2>จำนวนสถานีดับเพลิงและกู้ภัยที่มีการตรวจสอบข้อมูลยานพาหนะ</h2>
                    <!-- Filters Section -->
                    <div class="filters-card">
                        <div class="filter-grid">
                            <div class="filter-item">
                                <div class="field m-4">
                                    <label class="m-8 block">วันที่เริ่มต้น </label>
                                    <Calendar v-model="starttime" showIcon class="w-full" />
                                </div>
                            </div>
                            <div class="filter-item">
                                <div class="field m-4">
                                    <label class="m-8 block">วันที่สิ้นสุด </label>
                                    <Calendar v-model="endtime" showIcon class="w-full" />
                                </div>
                            </div>
                            <div class="filter-button mb-3">
                                <Button
                                    @click="getReportData2201"
                                    icon="pi pi-refresh"
                                    label="Generate Report"
                                    :loading="loading"
                                    class="p-button-primary w-full"
                                />
                            </div>
                        </div>
                    </div>

                    <div class="stats-summary">
                        <div class="stat-card total-records">
                            <h3>สถานีดับเพลิงทั้งหมด: {{ data.metadata.totalRecords }}</h3>
                        </div>
                    </div>
                    <Chart type="pie" :data="stationChartData" :options="enhancedChartOptions" class="chart-container" />
                </div>
            </div>

            <!-- Chart 2202 -->
            <div class="chart-box">
                <div class="chart-card">
                    <h2>สภาพความพร้อมใช้อุปกรณ์ยานพาหนะของหน่วยงาน</h2>
                    <!-- Filters Section -->
                    <div class="filters-card">
                        <div class="filter-grid">
                            <div class="filter-item">
                                <div class="field">
                                    <label>วันที่เริ่มต้น</label>
                                    <Calendar v-model="starttime2" showIcon class="w-full" />
                                </div>
                            </div>
                            <div class="filter-item">
                                <div class="field">
                                    <label>วันที่สิ้นสุด </label>
                                    <Calendar v-model="endtime2" showIcon class="w-full" />
                                </div>
                            </div>
                            <div class="filter-button">
                                <Button
                                    @click="getReportData2202"
                                    icon="pi pi-refresh"
                                    label="Generate Report"
                                    :loading="loading"
                                    class="p-button-primary w-full"
                                />
                            </div>
                        </div>
                    </div>

                    <div class="stats-summary">
                        <div class="stat-card total-records">
                            <h3>ยานพาหนะทั้งหมด: {{ totalVehiclesSum }}</h3>
                        </div>
                    </div>
                    <Chart type="pie" :data="organizeChartData" :options="enhancedChartOptions" class="chart-container" />
                </div>
            </div>
        </div>

        <div class="charts-wrapper">
            <!-- Chart 2203 -->
            <div class="chart-box">
                <div class="chart-card">
                    <h2>ร้อยละของหัวจ่ายน้ำดับเพลิง (ประปาหัวแดง) ที่มีการตรวจสอบสภาพความพร้อมใช้งาน</h2>
                    <!-- Filters Section -->
                    <div class="filters-card">
                        <div class="filter-grid">
                            <div class="filter-button">
                                <Button
                                    @click="getReportData2203"
                                    icon="pi pi-refresh"
                                    label="Generate Report"
                                    :loading="loading"
                                    class="p-button-primary w-full"
                                />
                            </div>
                        </div>
                    </div>

                    <div class="stats-summary">
                        <div class="stat-card total-records">
                            <h3>หัวจ่ายน้ำดับเพลิงทั้งหมด: {{ data2203.total || 0 }}</h3>
                        </div>
                    </div>
                    <Chart type="pie" :data="fireHydrantChartData" :options="enhancedChartOptions" class="chart-container" />
                </div>
            </div>

            <!-- Chart 2204 -->
            <div class="chart-box">
                <div class="chart-card">
                    <h2>ร้อยละของเครื่องดับเพลิงชนิดหาบหามที่มีการตรวจสอบสภาพความพร้อมใช้งาน</h2>
                    <!-- Filters Section -->
                    <div class="filters-card">
                        <div class="filter-grid">
                            <div class="filter-button">
                                <Button
                                    @click="getReportData2204"
                                    icon="pi pi-refresh"
                                    label="Generate Report"
                                    :loading="loading"
                                    class="p-button-primary w-full"
                                />
                            </div>
                        </div>
                    </div>

                    <div class="stats-summary">
                        <div class="stat-card total-records">
                            <h3>เครื่องดับเพลิงชนิดหาบหามทั้งหมด: {{ data2204.total || 0 }}</h3>
                        </div>
                    </div>
                    <Chart type="pie" :data="portableFirePumpChartData" :options="enhancedChartOptions" class="chart-container" />
                </div>
            </div>
        </div>

        <div class="charts-wrapper">
            <!-- Chart 2205 -->
            <div class="chart-box">
                <div class="chart-card">
                    <h2>จำนวนสถานะของถังดับเพลิงแบบยกหิ้ว</h2>
                    <!-- Filters Section -->
                    <div class="filters-card">
                        <div class="filter-grid">
                            <div class="filter-item">
                                <div class="field">
                                    <label>วันที่เริ่มต้น</label>
                                    <Calendar v-model="starttime5" showIcon class="w-full" />
                                </div>
                            </div>
                            <div class="filter-item">
                                <div class="field">
                                    <label>วันที่สิ้นสุด </label>
                                    <Calendar v-model="endtime5" showIcon class="w-full" />
                                </div>
                            </div>
                            <div class="filter-button">
                                <Button
                                    @click="getReportData2205"
                                    icon="pi pi-refresh"
                                    label="Generate Report"
                                    :loading="loading"
                                    class="p-button-primary w-full"
                                />
                            </div>
                        </div>
                    </div>

                    <div class="stats-summary">
                        <div class="stat-card total-records">
                            <h3>ถังดับเพลิงทั้งหมด: {{ data2205.statusSummary.total }}</h3>
                        </div>
                    </div>
                    <Chart type="pie" :data="extinguisherChartData" :options="enhancedChartOptions" class="chart-container" />
                </div>
            </div>

            <!-- Chart 2219 -->
            <div class="chart-box">
                <div class="chart-card">
                    <h2>จำนวนชุมชนที่มีการนำเข้าข้อมูลทรัพยากรด้านการป้องกันและบรรเทาสาธารณภัย</h2>
                    <!-- Filters Section -->
                    <div class="filters-card">
                        <div class="filter-grid">
                            <div class="filter-item">
                                <div class="field">
                                    <label for="provinceOptions">{{ $t('province') }}</label>
                                    <Dropdown
                                        v-model="selectedProvince"
                                        :options="provinceOptions"
                                        optionLabel="province_name"
                                        :filter="true"
                                        :placeholder="$t('placeholderSelectBox')"
                                        :showClear="true"
                                        :clearFilterDropdown="dropdownClearFilerValue"
                                    >
                                        <template #value="provinceOptions">
                                            <div v-if="provinceOptions.value">
                                                <div>{{ provinceOptions.value.province_name }}</div>
                                            </div>
                                        </template>
                                        <template #option="provinceOptions">
                                            <div>{{ provinceOptions.option.province_name }}</div>
                                        </template>
                                    </Dropdown>
                                </div>
                            </div>
                            <div class="filter-item">
                                <div class="field">
                                    <label for="amphurOptions">{{ $t('amphur') }}</label>
                                    <Dropdown
                                        :disabled="isDisabledAmphur == 1"
                                        v-model="selectedAmphur"
                                        :options="amphurOptions"
                                        optionLabel="amphur_name"
                                        :filter="true"
                                        :placeholder="$t('placeholderSelectBox')"
                                        :showClear="true"
                                        :clearFilterDropdown="dropdownClearFilerValue"
                                    >
                                        <template #value="amphurOptions">
                                            <div v-if="amphurOptions.value">
                                                <div>{{ amphurOptions.value.amphur_name }}</div>
                                            </div>
                                        </template>
                                        <template #option="amphurOptions">
                                            <div>{{ amphurOptions.option.amphur_name }}</div>
                                        </template>
                                    </Dropdown>
                                </div>
                            </div>
                            <div class="filter-button">
                                <Button
                                    @click="getReportData2219"
                                    icon="pi pi-refresh"
                                    label="Generate Report"
                                    :loading="loading"
                                    class="p-button-primary w-full"
                                />
                            </div>
                        </div>
                    </div>

                    <div class="stats-summary">
                        <div class="stat-card total-records">
                            <h3>จำนวนชุมชนทั้งหมดใน {{ selectedArea }}: {{ data2219.totalSummary.totalCommunity || 0 }}</h3>
                        </div>
                    </div>
                    <Chart type="bar" :data="totalResourceData" :options="enhancedChartOptions" class="chart-container" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    name: 'Dashboard',

    data() {
        return {
            loading: false,
            starttime: new Date(), // Today
            endtime: new Date(), // Today
            starttime2: new Date(),
            endtime2: new Date(),
            starttime5: new Date(),
            endtime5: new Date(),

            data2219: {
                community: [],
                totalSummary: {
                    totalCommunity: 0,
                    totalExtinguisher: 0,
                    totalPortableFirePump: 0,
                    totalFireHydrant: 0,
                    totalVolunteer: 0,
                    totalEquipment: 0
                }
            },
            totalResourceData: {
                labels: [],
                datasets: [
                    {
                        data: [],
                        backgroundColor: [],
                        hoverBackgroundColor: [],
                        percentages: []
                    }
                ]
            },
            dropdownClearFilerValue: null,
            selectedTambon: null,
            isDisabledTambon: 1,
            selectedProvince: null,
            amphurOptions: [],
            provinceOptions: [],
            selectedAmphur: null,
            isDisabledAmphur: 1,
            io_postcode: '',
            io_selectedProvince: null,
            io_selectedAmphur: null,
            io_selectedTambon: null,
            io_isDisabledAmphur: 1,
            io_isDisabledTambon: 1,
            data2204: {
                total: 0,
                normal: 0,
                damaged: 0,
                repairing: 0,
                waitingForDisposal: 0,
                disposed: 0,
                equipmentDamaged: 0,

                statusPercentages: {
                    normal: '0%',
                    damaged: '0%',
                    repairing: '0%',
                    waitingForDisposal: '0%',
                    disposed: '0%',
                    equipmentDamaged: '0%'
                }
            },
            portableFirePumpChartData: {
                labels: [],
                datasets: [
                    {
                        data: [],
                        backgroundColor: [],
                        hoverBackgroundColor: [],
                        percentages: []
                    }
                ]
            },

            data2203: {
                total: 0,
                normal: 0,
                damaged: 0,
                installing: 0,
                statusPercentages: {
                    normal: '0%',
                    damaged: '0%',
                    installing: '0%'
                }
            },
            fireHydrantChartData: {
                labels: [],
                datasets: [
                    {
                        data: [],
                        backgroundColor: [],
                        hoverBackgroundColor: [],
                        percentages: []
                    }
                ]
            },

            data2202: {
                totalLogsData: 0,
                vehicleStatusSummary: []
            },
            data: {
                metadata: {
                    totalRecords: 0,
                    summaryPercentage: []
                },
                data: []
            },
            data2205: {
                statusSummary: {
                    total: '0',
                    normal: '0',
                    damaged: '0',
                    statusPercentages: {
                        normal: '0%',
                        damaged: '0%'
                    }
                }
            },

            extinguisherChartData: {
                labels: [],
                datasets: [
                    {
                        data: [],
                        backgroundColor: [],
                        hoverBackgroundColor: []
                    }
                ]
            },
            // starttime: null,
            // endtime: null,
            // starttime2: null,
            // endtime2: null,
            // loading: false,
            // starttime3: null,
            // endtime3: null,
            // starttime5: null,
            // endtime5: null,

            // Add computed chart data
            stationChartData: {
                labels: [],
                datasets: [
                    {
                        data: [],
                        backgroundColor: [],
                        hoverBackgroundColor: []
                    }
                ]
            },

            organizeChartData: {
                labels: [],
                datasets: [
                    {
                        data: [],
                        backgroundColor: [],
                        hoverBackgroundColor: []
                    }
                ]
            },

            enhancedChartOptions: {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    legend: {
                        position: 'bottom',
                        labels: {
                            color: '#495057',
                            usePointStyle: true,
                            font: {
                                size: 12
                            }
                        }
                    },
                    tooltip: {
                        callbacks: {
                            label: function (context) {
                                return `${context.label}: ${context.raw} (${context.dataset.percentages[context.dataIndex]})`;
                            }
                        }
                    }
                }
            }
        };
    },

    computed: {
        totalVehiclesSum() {
            if (this.data2202.vehicleStatusSummary.length > 0) {
                return this.data2202.vehicleStatusSummary.reduce((acc, item) => acc + parseInt(item.total_vehicles), 0);
            }
            return 0;
        },
        selectedArea() {
            if (this.selectedAmphur) {
                return `เขต${this.selectedAmphur.amphur_name}`;
            }
            return 'กรุงเทพมหานคร';
        }
    },

    created() {
        this.initialChartData();
        this.initialData();
    },

    watch: {
        async selectedProvince(val) {
            this.selectedAmphur = null;
            if (val != null) {
                this.isDisabledAmphur = 0;
                await this.axios
                    .post(`${this.$url_service}/general/country`, {
                        body: {
                            topic: 'get-amphur',
                            province_id: val.province_id
                        }
                    })
                    .then((response) => {
                        (this.amphurOptions = response.data.data),
                            this.amphurOptions.splice(0, 0, {
                                amphur_id: 'getall',
                                amphur_name: this.$i18n.t('selectAll')
                            });
                    });
            } else {
                this.isDisabledAmphur = 1;
                this.selectedAmphur = null;
            }
        },

        async selectedAmphur(val) {
            this.selectedTambon = null;
            if (val != null) {
                this.isDisabledTambon = 0;
                await this.axios
                    .post(`${this.$url_service}/general/country`, {
                        body: {
                            topic: 'get-tambon',
                            amphur_id: val.amphur_id
                        }
                    })
                    .then((response) => {
                        (this.tambonOptions = response.data.data),
                            this.tambonOptions.splice(0, 0, {
                                tambon_id: 'getall',
                                tambon_name: this.$i18n.t('selectAll')
                            });
                    });
            } else {
                this.isDisabledTambon = 1;
                this.selectedTambon = null;
            }
        },

        async io_selectedProvince(val) {
            if (val != null) {
                this.io_isDisabledAmphur = 0;
                await this.axios
                    .post(`${this.$url_service}/general/country`, {
                        body: {
                            topic: 'get-amphur',
                            province_id: val.province_id
                        }
                    })
                    .then((response) => (this.amphurOptions = response.data.data));
            } else {
                this.io_isDisabledAmphur = 1;
                this.io_selectedAmphur = null;
            }
        },

        async io_selectedAmphur(val) {
            if (val != null) {
                this.io_isDisabledTambon = 0;
                await this.axios
                    .post(`${this.$url_service}/general/country`, {
                        body: {
                            topic: 'get-tambon',
                            amphur_id: val.amphur_id
                        }
                    })
                    .then((response) => (this.tambonOptions = response.data.data));
            } else {
                this.io_isDisabledTambon = 1;
                this.io_selectedTambon = null;
            }
        },

        async io_selectedTambon(val) {
            if (val != null) {
                await this.axios
                    .post(`${this.$url_service}/general/country`, {
                        body: {
                            topic: 'get-postcode',
                            tambon_id: val.tambon_id
                        }
                    })
                    .then((response) => {
                        if (val.tambon_id !== null && val.tambon_id !== 'null') {
                            this.io_postcode = response.data.data.postcode;
                        }
                    });
            } else {
                this.io_postcode = '';
            }
        }
    },

    methods: {
        async initialChartData() {
            try {
                this.loading = true;
                // Load all reports in parallel
                await Promise.all([
                    this.getReportData2201(),
                    this.getReportData2202(),
                    this.getReportData2203(),
                    this.getReportData2204(),
                    this.getReportData2205(),
                    this.getReportData2219()
                ]);
            } catch (error) {
                this.$toast.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Failed to load initial data',
                    life: 3000
                });
            } finally {
                this.loading = false;
            }
        },

        async initialData() {
            const userOrg = this.checkPermission() ? null : this.getUserOrganize(); //เช็คสิทธิ์
            this.ms = true;
            this.filter = '';
            this.cloneTable = [];
            this.loading = true;
            await this.axios.post(`${this.$url_service}/initial/organize`, {
                body: {
                    topic: 'get-table',
                    userOrg
                }
            });

            await this.axios
                .post(`${this.$url_service}/initial/option`, {
                    body: { group: 'dg-01' }
                })
                .then((response) => {
                    (this.organizeTypeOptions = response.data.data),
                        this.organizeTypeOptions.splice(0, 0, {
                            system_id: 'getall',
                            system_name: this.$i18n.t('selectAll')
                        });
                });

            await this.axios
                .post(`${this.$url_service}/general/country`, {
                    body: {
                        topic: 'get-province'
                    }
                })
                .then((response) => {
                    (this.provinceOptions = response.data.data),
                        this.provinceOptions.splice(0, 0, {
                            province_id: 'getall',
                            province_name: this.$i18n.t('selectAll')
                        });
                });
            await this.axios
                .post(`${this.$url_service}/initial/option`, {
                    body: { group: 'dg-04' }
                })
                .then((response) => {
                    this.communicationTypeOptions = response.data.data;
                });

            await this.axios
                .post(`${this.$url_service}/initial/option`, {
                    body: { group: 'dg-04' }
                })
                .then((response) => {
                    this.communicationTypeOptions = response.data.data;
                });

            this.loading = false;
        },

        async searchMenu() {
            await this.axios
                .post(`${this.$url_service}/initial/option`, {
                    body: { group: 'dg-01' }
                })
                .then((response) => {
                    (this.organizeTypeOptions = response.data.data),
                        this.organizeTypeOptions.splice(0, 0, {
                            system_id: 'getall',
                            system_name: this.$i18n.t('selectAll')
                        });
                });

            await this.axios
                .post(`${this.$url_service}/general/country`, {
                    body: {
                        topic: 'get-province'
                    }
                })
                .then((response) => {
                    (this.provinceOptions = response.data.data),
                        this.provinceOptions.splice(0, 0, {
                            province_id: 'getall',
                            province_name: this.$i18n.t('selectAll')
                        });
                });
            await this.axios
                .post(`${this.$url_service}/initial/option`, {
                    body: { group: 'dg-04' }
                })
                .then((response) => {
                    this.communicationTypeOptions = response.data.data;
                });

            await this.axios
                .post(`${this.$url_service}/initial/option`, {
                    body: { group: 'dg-04' }
                })
                .then((response) => {
                    this.communicationTypeOptions = response.data.data;
                });
        },

        async getReportData2201() {
            if (!this.starttime || !this.endtime) {
                // Set default dates if not selected
                this.starttime = new Date();
                this.endtime = new Date();
            }
            if (!this.starttime || !this.endtime) {
                this.$toast.add({
                    severity: 'warn',
                    summary: 'Warning',
                    detail: 'Please select both start and end dates',
                    life: 3000
                });
                return;
            }

            this.loading = true;
            try {
                const response = await axios.post(
                    `${this.$url_service}/firestation/weekly/equipment/report`,
                    { starttime: this.starttime, endtime: this.endtime },
                    { headers: { 'Content-Type': 'application/json' } }
                );

                const data = response.data;
                if (data.code === 'success') {
                    this.data = data;
                    this.updateChartData(data.metadata.summaryPercentage);

                    this.$toast.add({
                        severity: 'success',
                        summary: 'Success',
                        detail: 'Report generated successfully',
                        life: 3000
                    });
                } else {
                    throw new Error(data.message);
                }
            } catch (error) {
                this.$toast.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: error.message || 'Failed to generate report',
                    life: 3000
                });
            } finally {
                this.loading = false;
            }
        },

        updateChartData(summaryData) {
            // Generate random colors for each station
            const colors = summaryData.map(() => this.getRandomColor());

            this.stationChartData = {
                labels: summaryData.map((item) => item.fs_tname),
                datasets: [
                    {
                        data: summaryData.map((item) => item.count),
                        backgroundColor: colors,
                        hoverBackgroundColor: colors.map((color) => this.adjustBrightness(color, 20)),
                        percentages: summaryData.map((item) => item.percentage)
                    }
                ]
            };
        },

        async getReportData2202() {
            if (!this.starttime2 || !this.endtime2) {
                // Set default dates if not selected
                this.starttime2 = new Date();
                this.endtime2 = new Date();
            }

            if (!this.starttime2 || !this.endtime2) {
                this.$toast.add({
                    severity: 'warn',
                    summary: 'Warning',
                    detail: 'Please select both start and end dates',
                    life: 3000
                });
                return;
            }

            this.loading = true;
            try {
                const response = await axios.post(
                    `${this.$url_service}/bangkokOrg/weekly/equipment/report`,
                    { starttime: this.starttime2, endtime: this.endtime2 },
                    { headers: { 'Content-Type': 'application/json' } }
                );

                const data = response.data;
                if (data.code === 'success') {
                    this.data2202 = {
                        totalLogsData: data.totalLogsData,
                        vehicleStatusSummary: data.vehicleStatusSummary
                    };
                    this.updateChartData2202(data.vehicleStatusSummary);

                    this.$toast.add({
                        severity: 'success',
                        summary: 'Success',
                        detail: 'Report 2202 generated successfully',
                        life: 3000
                    });
                } else {
                    throw new Error(data.message);
                }
            } catch (error) {
                this.$toast.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: error.message || 'Failed to generate report',
                    life: 3000
                });
            } finally {
                this.loading = false;
            }
        },

        updateChartData2202(summaryData) {
            const colors = summaryData.map(() => this.getRandomColor());

            this.organizeChartData = {
                labels: summaryData.map((item) => item.status || 'ไม่ระบุ'),
                datasets: [
                    {
                        data: summaryData.map((item) => parseInt(item.total_vehicles)),
                        backgroundColor: colors,
                        hoverBackgroundColor: colors.map((color) => this.adjustBrightness(color, 20)),
                        percentages: summaryData.map((item) => item.percentage)
                    }
                ]
            };
        },

        async getReportData2203() {
            this.loading = true;
            try {
                const response = await axios.post(`${this.$url_service}/firehydrant/status/report`);
                const { data } = response;

                if (data.code === 'success') {
                    this.data2203 = data.statusSummary;
                    this.updateChartData2203(data.statusSummary);

                    this.$toast.add({
                        severity: 'success',
                        summary: 'Success',
                        detail: 'Report 2203 generated successfully',
                        life: 3000
                    });
                } else {
                    throw new Error('Failed to fetch data');
                }
            } catch (error) {
                this.$toast.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: error.message || 'Failed to generate report',
                    life: 3000
                });
            } finally {
                this.loading = false;
            }
        },

        updateChartData2203(summaryData) {
            const labels = ['ปกติ', 'ชำรุด', 'อยู่ระหว่างติดตั้ง'];
            const values = [parseInt(summaryData.normal), parseInt(summaryData.damaged), parseInt(summaryData.installing)];

            const percentages = [
                summaryData.statusPercentages.normal,
                summaryData.statusPercentages.damaged,
                summaryData.statusPercentages.installing
            ];

            const colors = ['#28a745', '#dc3545', '#ffc107'];

            this.fireHydrantChartData = {
                labels,
                datasets: [
                    {
                        data: values,
                        backgroundColor: colors,
                        hoverBackgroundColor: colors.map((color) => this.adjustBrightness(color, 20)),
                        percentages
                    }
                ]
            };
        },

        async getReportData2204() {
            this.loading = true;
            try {
                const response = await axios.post(`${this.$url_service}/portable/firepump/report`);
                const { data } = response;

                if (data.code === 'success') {
                    this.data2204 = data.statusSummary;
                    this.updateChartData2204(data.statusSummary);

                    this.$toast.add({
                        severity: 'success',
                        summary: 'Success',
                        detail: 'Report 2204 generated successfully',
                        life: 3000
                    });
                } else {
                    throw new Error('Failed to fetch data');
                }
            } catch (error) {
                this.$toast.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: error.message || 'Failed to generate report',
                    life: 3000
                });
            } finally {
                this.loading = false;
            }
        },

        updateChartData2204(summaryData) {
            const labels = ['พร้อมใช้', 'ซ่อม', 'ชำรุด', 'รอจำหน่าย', 'จำหน่าย', 'อุปกรณ์ชำรุด'];
            const values = [
                parseInt(summaryData.normal),
                parseInt(summaryData.repairing),
                parseInt(summaryData.damaged),
                parseInt(summaryData.waitingForDisposal),
                parseInt(summaryData.disposed),
                parseInt(summaryData.equipmentDamaged)
            ];

            const percentages = [
                summaryData.normal,
                summaryData.repairing,
                summaryData.damaged,
                summaryData.waitingForDisposal,
                summaryData.disposed,
                summaryData.equipmentDamaged
            ];

            const colors = ['#28a745', '#dc3545', '#ffc107', '#007bff', '#6c757d', '#17a2b8'];

            this.portableFirePumpChartData = {
                labels,
                datasets: [
                    {
                        data: values,
                        backgroundColor: colors,
                        hoverBackgroundColor: colors.map((color) => this.adjustBrightness(color, 20)),
                        percentages
                    }
                ]
            };
        },

        async getReportData2205() {
            if (!this.starttime5 || !this.endtime5) {
                this.$toast.add({
                    severity: 'warn',
                    summary: 'Warning',
                    detail: 'Please select both start and end dates',
                    life: 3000
                });
                return;
            }

            this.loading = true;
            try {
                const response = await axios.post(`${this.$url_service}/fire/extinguisher/report`, {
                    starttime: this.starttime5,
                    endtime: this.endtime5
                });

                const { data } = response;
                if (data.code === 'success') {
                    this.data2205.statusSummary = data.statusSummary;
                    this.updateChartData2205(data.statusSummary);
                    this.$toast.add({
                        severity: 'success',
                        summary: 'Success',
                        detail: 'Report generated successfully',
                        life: 3000
                    });
                } else {
                    throw new Error(data.message);
                }
            } catch (error) {
                this.$toast.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: error.message || 'Failed to generate report',
                    life: 3000
                });
            } finally {
                this.loading = false;
            }
        },

        updateChartData2205(summaryData) {
            const labels = ['ปกติ', 'ชำรุด'];
            const values = [parseInt(summaryData.normal), parseInt(summaryData.damaged)];
            const percentages = [summaryData.statusPercentages.normal, summaryData.statusPercentages.damaged];
            const colors = ['#4CAF50', '#F44336'];

            this.extinguisherChartData = {
                labels: labels.map((label, index) => `${label} (${percentages[index]})`),
                datasets: [
                    {
                        data: values,
                        backgroundColor: colors,
                        hoverBackgroundColor: colors.map((color) => this.adjustBrightness(color, 20)),
                        percentages
                    }
                ]
            };
        },

        async getReportData2219() {
            if (!this.selectedProvince) {
                this.selectedProvince = { province_name: 'กรุงเทพมหานคร' };
            }

            this.loading = true;
            try {
                let requestBody = {};

                // Set request body based on selection
                if (this.selectedAmphur) {
                    requestBody = { District: this.selectedAmphur.amphur_name };
                } else {
                    requestBody = { Province: 'กรุงเทพมหานคร' };
                }

                const response = await axios.post(`${this.$url_service}/community/resources/report`, requestBody);

                const { data } = response;
                if (data.code === 'success') {
                    this.data2219.totalSummary = data.totalSummary;
                    this.updateChartData2219(data.totalSummary);

                    this.$toast.add({
                        severity: 'success',
                        summary: 'Success',
                        detail: 'Report generated successfully',
                        life: 3000
                    });
                } else {
                    throw new Error(data.message);
                }
            } catch (error) {
                this.$toast.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: error.message || 'Failed to generate report',
                    life: 3000
                });
            } finally {
                this.loading = false;
            }
        },

        updateChartData2219(summaryData) {
            const labels = ['ชุมชน', 'ถังดับเพลิง', 'เครื่องสูบน้ำ', 'หัวจ่ายน้ำ', 'อาสาสมัคร', 'อุปกรณ์'];

            const data = [
                parseInt(summaryData.totalCommunity),
                parseInt(summaryData.totalExtinguisher),
                parseInt(summaryData.totalPortableFirePump),
                parseInt(summaryData.totalFireHydrant),
                parseInt(summaryData.totalVolunteer),
                parseInt(summaryData.totalEquipment)
            ];

            const colors = ['#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0', '#9966FF', '#FF9F40'];

            this.totalResourceData = {
                labels: labels,
                datasets: [
                    {
                        label: 'จำนวน',
                        data: data,
                        backgroundColor: colors,
                        hoverBackgroundColor: colors.map((color) => this.adjustBrightness(color, 20))
                    }
                ]
            };
        },

        getRandomColor() {
            const letters = '0123456789ABCDEF';
            let color = '#';
            for (let i = 0; i < 6; i++) {
                color += letters[Math.floor(Math.random() * 16)];
            }
            return color;
        },

        adjustBrightness(color, percent) {
            const num = parseInt(color.replace('#', ''), 16),
                amt = Math.round(2.55 * percent),
                R = (num >> 16) + amt,
                G = ((num >> 8) & 0x00ff) + amt,
                B = (num & 0x0000ff) + amt;
            return (
                '#' +
                (
                    0x1000000 +
                    (R < 255 ? (R < 1 ? 0 : R) : 255) * 0x10000 +
                    (G < 255 ? (G < 1 ? 0 : G) : 255) * 0x100 +
                    (B < 255 ? (B < 1 ? 0 : B) : 255)
                )
                    .toString(16)
                    .slice(1)
            );
        }
    }
};
</script>
<style scoped>
.dashboard-container {
    width: 100%;
    padding: 1rem;
}

.charts-wrapper {
    display: flex;
    flex-direction: row;
    gap: 1rem;
    width: 100%;
}

.chart-box {
    flex: 1;
    min-width: 0;
}

.chart-card {
    background: white;
    padding: 1.5rem;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.filter-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 1rem;
    margin-bottom: 1rem;
}

.chart-container {
    margin-top: 1rem;
    height: 300px;
}

/* Responsive layout */
@media (max-width: 992px) {
    .charts-wrapper {
        flex-direction: column;
    }

    .chart-box {
        width: 100%;
    }
}
</style>
